import { AppProviders } from '@/app/providers'

/**
 * App.tsx
 * Thin wrapper: just renders <AppProviders />.
 * All providers, routing, and layout are in src/app/providers.tsx.
 */
export function App() {
  return <AppProviders />
}

// Default export kept for any legacy import
export default App

